import { ArticleParagraph1 } from '@cian/ui-kit';

import { type FC } from 'react';

import { LayoutBlock } from '../LayoutBlock';

interface IAboutProps {
  contentText: string;
  sectionTabTitle: string;
  title: string;
}

export const About: FC<IAboutProps> = ({ contentText, sectionTabTitle, title }) => {
  return (
    <LayoutBlock id="about" sectionTabTitle={sectionTabTitle} title={title}>
      <ArticleParagraph1 whiteSpace="pre-wrap">{contentText}</ArticleParagraph1>
    </LayoutBlock>
  );
};
